import { render, staticRenderFns } from "./VirtualDataTable.vue?vue&type=template&id=665bd752&scoped=true"
import script from "./VirtualDataTable.vue?vue&type=script&lang=js"
export * from "./VirtualDataTable.vue?vue&type=script&lang=js"
import style0 from "./VirtualDataTable.vue?vue&type=style&index=0&id=665bd752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665bd752",
  null
  
)

export default component.exports